import { useVideoContext, useRoomState } from '@alucio/video';
import { useEffect, useState } from 'react';
export default function useLocalDataTrack() {
    const { room } = useVideoContext();
    const roomState = useRoomState();
    const [localDataTrack, setLocalDatatrack] = useState();
    const [localParticipant, setLocalParticipant] = useState();
    useEffect(() => {
        if (roomState === 'connected') {
            setLocalParticipant(room.localParticipant);
        }
    }, [roomState]);
    const handleLocalParticipant = () => {
        if (localParticipant) {
            const handleTrackPublished = (publication) => {
                if (publication.kind === 'data') {
                    setLocalDatatrack(publication.track);
                }
            };
            localParticipant.on('trackPublished', handleTrackPublished);
            return () => {
                localParticipant.off('trackPublished', handleTrackPublished);
            };
        }
    };
    useEffect(handleLocalParticipant, [localParticipant]);
    if (localDataTrack) {
        return localDataTrack;
    }
}
//# sourceMappingURL=useLocalDataTrack.js.map